
import { mapMutations, mapGetters } from 'vuex';
import TextTabBar from '@/components/common/TextTabBar';
import ScheduleFilter from './ScheduleFilter.vue';
import AgeNGradeFilter from './AgeNGradeFilter.vue';

export default {
  name: 'DateNAgeFilter',
  components: {
    TextTabBar,
    ScheduleFilter,
    AgeNGradeFilter,
  },
  data() {
    return {
      tabList: [
        { text: '일정', value: 'schedule', ddAction: 'click_search_tab_schedule' },
        { text: '학년/나이', value: 'age', ddAction: 'click_search_tab_age' },
      ],
    };
  },
  computed: {
    ...mapGetters('search', ['activeBottomDrawerFilter']),
  },
  methods: {
    ...mapMutations('search', ['SET_ACTIVE_BOTTOM_DRAWER_FILTER']),
    onChangeTab(tabValue) {
      this.SET_ACTIVE_BOTTOM_DRAWER_FILTER(tabValue);
    },
  },
};
